import * as React from 'react';
import { Icon } from '@salesforce/design-system-react';

const customerIcon = () => (
	<Icon
		category="standard"
		name="customers"
		style={{backgroundColor: '#1A57A2'}}
	/>
);

export default customerIcon;


// WEBPACK FOOTER //
// ./src/lib/CustomerIcon.tsx